import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

const service = axios.create({
  baseURL: '/api', // 🚨 保持 /api 不变！由 Nginx 负责转发
  timeout: 50000 
})

service.interceptors.request.use(
  config => {
    const hasToken = getToken()
    if (hasToken) {
      config.headers['token'] = hasToken
      config.headers['Authorization'] = hasToken
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 200 || res.code === undefined) {
      return res
    }
    if (res.code === 504) {
       return res;
    }

    Message({
      message: (res.msg || res.message || '系统错误'),
      type: 'error',
      duration: 5 * 1000
    })

    if (res.code === 501 || res.code === 401 || res.code === 50008 || res.code === 50012) {
      MessageBox.confirm('登录状态已失效，请重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      })
    }
    return Promise.reject(new Error(res.msg || res.message || 'Error'))
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
